import { z } from "zod";
export const cancelBookingSchema = z.object({
    reason: z.string().min(1).max(2000),
    evidence_url: z.url().optional(),
});
